var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClose1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_36655_175053",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 32,
    height: 32
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_36655_175053)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.53366 25.3333L6.66699 23.4666L14.1337 16L6.66699 8.53329L8.53366 6.66663L16.0003 14.1333L23.467 6.66663L25.3337 8.53329L17.867 16L25.3337 23.4666L23.467 25.3333L16.0003 17.8666L8.53366 25.3333Z",
    fill: "#4E4E4E"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose1);
export default __webpack_public_path__ + "static/media/Close-1.a2097f8012bf30119c0f72ccaab52f46.svg";
export { ForwardRef as ReactComponent };